import React, { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import { Menu } from "lucide-react";
import { useAuth } from "../AuthContext";
import { useAuthModal } from "../AuthModalContext";
import SiteNavigationDrawer from "./SiteNavigationDrawer";

export default function GlobalDrawer() {
  const location = useLocation();
  const { user, profile } = useAuth();
  const { openAuthModal } = useAuthModal();
  const [open, setOpen] = useState(false);
  const toggleRef = useRef(null);
  // Home has a launcher in its header and uses this same shared drawer.
  const hidden = location.pathname === "/" || location.pathname === "/app-preview";

  useEffect(() => {
    document.documentElement.classList.toggle("has-global-navigation", !hidden);
    return () => document.documentElement.classList.remove("has-global-navigation");
  }, [hidden]);
  useEffect(() => { setOpen(false); }, [location.key]);

  if (hidden) return null;
  return <>
    <div className="global-navigation-launcher" style={{ "--navigation-surface": "#fff", "--navigation-text": "#0a1d44" }}>
      <button ref={toggleRef} type="button" data-global-drawer-toggle
        aria-label="Open navigation" aria-expanded={open} aria-controls="sc-navigation"
        onClick={() => setOpen(true)}
        style={{ position: "fixed", top: 72, right: 12, zIndex: 90, width: 44, height: 44,
          borderRadius: 12, border: "1px solid #dce1e7", background: "#fff", color: "#0a1d44",
          boxShadow: "0 8px 24px #0a1d4418", display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer" }}>
        <Menu size={22} aria-hidden="true"/><span className="global-navigation-label">Menu</span>
      </button>
    </div>
    <SiteNavigationDrawer returnFocusRef={toggleRef} open={open} onClose={() => setOpen(false)} user={user} email={profile?.email}
      onSignIn={() => openAuthModal({ mode: "signin", redirectTo: location.pathname + location.search + location.hash })}/>
  </>;
}
